module.exports = __webpack_public_path__ + "img/archive.f8b32c6a.svg";